module.exports = __webpack_public_path__ + "app/kiss-order/filter-2ydVeGRW.html";